import Vue, { getCurrentInstance } from 'vue'
import VueRouter, { NavigationGuard, Route } from 'vue-router'

/**
 * Equivalentes do vue-router 4 (useRouter / useRoute / onBeforeRouteLeave) para o Vue 2.7.
 * Os do vue2-helpers não servem: o useRoute guarda a rota do primeiro router criado
 * e o onBeforeRouteLeave acumula as guardas nas opções do componente a cada montagem.
 */

function instanciaAtual(nome: string) {
	const instancia = getCurrentInstance()
	if (!instancia) throw new Error(`${nome}() só pode ser usado dentro do setup()`)
	return instancia.proxy
}

export function useRouter(): VueRouter {
	return instanciaAtual('useRouter').$router
}

/** rota atual reativa: leia as propriedades na hora (route.params.id), não desestruture */
export function useRoute(): Route {
	const vm = instanciaAtual('useRoute')
	return new Proxy({} as Route, {
		get: (_, chave) => vm.$route[chave as keyof Route],
	})
}

const GUARDA_DE_SAIDA = '__guardaDeSaida'

// instala antes do mixin: é o install do vue-router que faz o Vue juntar as guardas em array
Vue.use(VueRouter)

// o vue-router 3 só lê beforeRouteLeave das opções do componente da rota;
// este mixin delega para a guarda registrada pelo onBeforeRouteLeave no setup da instância
Vue.mixin({
	beforeRouteLeave(to, from, next) {
		const guarda: NavigationGuard | undefined = (this as any)[GUARDA_DE_SAIDA]
		guarda ? guarda.call(this, to, from, next) : next()
	},
})

/** só funciona no componente da rota (como o beforeRouteLeave das opções) */
export function onBeforeRouteLeave(guarda: NavigationGuard) {
	const vm = instanciaAtual('onBeforeRouteLeave') as any
	vm[GUARDA_DE_SAIDA] = guarda
}
